import styled from "styled-components";

export const Main = styled.div<{ $isNoMinimize: boolean }>`
   position: relative;
   display: flex;
   align-items: center;
   flex-direction: column;
   justify-content: center;
   width: 150px;
   padding: 0;
   // transition: ${({ $isNoMinimize }) => $isNoMinimize ? 'all .3s linear' : 'none'};

   .summary {
      width: 100%;
      box-sizing: border-box;
      padding: 9px 10px;
      border: 1px solid #e5e7eb;
      border-radius: 9px;
      background: #f8fafc;
      color: #475569;
      overflow: hidden;
   }

   .summaryTop {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 6px;
      margin-bottom: 4px;
   }

   .summaryMode,
   .summaryStatus {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
   }

   .summaryMode {
      color: #1f2937;
      font-size: 12px;
      font-weight: 600;
   }

   .summaryStatus {
      flex: 0 0 auto;
      padding: 2px 5px;
      border-radius: 999px;
      font-size: 9px;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: .03em;

      &.ready {
         color: #087443;
         background: #dcfce7;
      }

      &.warning {
         color: #9a3412;
         background: #ffedd5;
      }
   }

   .summaryFile {
      display: block;
      overflow: hidden;
      color: #64748b;
      font-size: 10px;
      text-overflow: ellipsis;
      white-space: nowrap;
   }
`;

export const Editor = styled.div`
   width: 100%;
   box-sizing: border-box;
   color: #1f2937;

   .editorHeader {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 20px;
      padding-bottom: 22px;
      border-bottom: 1px solid #e5e7eb;

      h3 {
         margin: 3px 0 5px;
         color: #111827;
         font-size: 22px;
         font-weight: 650;
      }

      p {
         margin: 0;
         color: #64748b;
         font-size: 13px;
      }
   }

   .eyebrow,
   .sectionEyebrow {
      color: #0891b2;
      font-size: 10px;
      font-weight: 700;
      letter-spacing: .08em;
      text-transform: uppercase;
   }

   .editorStatus {
      flex: 0 0 auto;
      padding: 6px 9px;
      border-radius: 999px;
      font-size: 11px;
      font-weight: 600;

      &.ready {
         color: #166534;
         background: #dcfce7;
      }

      &.warning {
         color: #9a3412;
         background: #ffedd5;
      }
   }

   .section {
      padding: 22px 0;
      border-bottom: 1px solid #e5e7eb;
   }

   .sectionHeading {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 18px;
      margin-bottom: 14px;

      > div {
         display: flex;
         align-items: baseline;
         gap: 8px;
      }

      h4 {
         margin: 0;
         color: #1f2937;
         font-size: 15px;
         font-weight: 650;
      }

      > span {
         color: #94a3b8;
         font-size: 11px;
         text-align: right;
      }
   }

   .operationGrid {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 10px;
   }

   .operationOption {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 5px;
      min-height: 80px;
      padding: 12px;
      border: 1px solid #e2e8f0;
      border-radius: 10px;
      background: #fff;
      color: #64748b;
      cursor: pointer;
      text-align: left;
      transition: border-color .15s ease, box-shadow .15s ease, background .15s ease;

      &:hover {
         border-color: #67e8f9;
         background: #f0fdff;
      }

      &.active {
         border-color: #06b6d4;
         background: #ecfeff;
         box-shadow: 0 0 0 2px rgba(6, 182, 212, .12);
         color: #155e75;
      }
   }

   .operationOptionTitle {
      color: #1f2937;
      font-size: 13px;
      font-weight: 650;
   }

   .operationOption > span:last-child {
      font-size: 11px;
      line-height: 1.35;
   }

   .sourceGrid {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 12px;

      .select {
         min-width: 0;

         h4 {
            width: auto;
            min-width: 74px;
         }
      }
   }

   .selectedFileCard {
      display: flex;
      align-items: center;
      gap: 10px;
      min-width: 0;
      margin-top: 14px;
      padding: 11px 12px;
      border: 1px solid #e2e8f0;
      border-radius: 10px;
      background: #f8fafc;

      &.connected {
         border-color: #a5f3fc;
         background: #ecfeff;
      }
   }

   .fileIcon {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 0 0 30px;
      width: 30px;
      height: 30px;
      border-radius: 8px;
      background: #cffafe;
      color: #0891b2;
   }

   .fileMeta {
      display: flex;
      flex-direction: column;
      min-width: 0;
      gap: 2px;
   }

   .fileLabel,
   .fileHint {
      color: #94a3b8;
      font-size: 10px;
   }

   .fileName {
      overflow: hidden;
      color: #334155;
      font-size: 12px;
      font-weight: 600;
      text-overflow: ellipsis;
      white-space: nowrap;
   }

   .iconButton {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 0 0 auto;
      width: 27px;
      height: 27px;
      margin-left: auto;
      border: 0;
      border-radius: 7px;
      background: transparent;
      color: #94a3b8;
      cursor: pointer;

      &:hover {
         background: #fee2e2;
         color: #dc2626;
      }
   }

   .sourceActions {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 9px;
      margin-top: 12px;

      > span {
         color: #94a3b8;
         font-size: 11px;
      }
   }

   .secondaryButton,
   .uploadButton {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 7px;
      min-height: 34px;
      padding: 0 11px;
      border: 1px solid #cbd5e1;
      border-radius: 8px;
      background: #fff;
      color: #475569;
      font-size: 12px;
      font-weight: 600;
      cursor: pointer;
      transition: background .15s ease, border-color .15s ease, color .15s ease;

      &:hover {
         border-color: #06b6d4;
         background: #ecfeff;
         color: #0e7490;
      }

      &:disabled {
         cursor: wait;
         opacity: .6;
      }
   }

   .inlineError {
      margin-top: 8px;
      color: #b91c1c;
      font-size: 11px;
   }

   .referenceSection {
      .sectionHeading {
         align-items: center;
      }
   }

   .requirements {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;

      span {
         display: inline-flex;
         align-items: center;
         gap: 5px;
         padding: 5px 8px;
         border-radius: 6px;
         background: #f1f5f9;
         color: #64748b;
         font-size: 11px;

         svg {
            color: #94a3b8;
         }

         &.complete {
            background: #ecfdf5;
            color: #166534;

            svg {
               color: #16a34a;
            }
         }
      }
   }

   .annotationEditor {
      margin-top: 16px;
      padding: 12px;
      border: 1px solid #e2e8f0;
      border-radius: 10px;
      background: #f8fafc;
   }

   .annotationToolbar {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 7px;
      padding-bottom: 11px;
      border-bottom: 1px solid #e2e8f0;
   }

   .uploadButton {
      position: relative;
      overflow: hidden;
      min-height: 32px;
      background: #06b6d4;
      border-color: #06b6d4;
      color: #fff;

      &:hover {
         background: #0891b2;
         border-color: #0891b2;
         color: #fff;
      }

      input {
         position: absolute;
         inset: 0;
         width: 100%;
         height: 100%;
         cursor: pointer;
         opacity: 0;
      }
   }

   .annotationLabelInput {
      box-sizing: border-box;
      width: 145px;
      height: 32px;
      padding: 0 9px;
      border: 1px solid #cbd5e1;
      border-radius: 7px;
      background: #fff;
      color: #334155;
      font-size: 12px;

      &:focus {
         outline: 2px solid rgba(6, 182, 212, .25);
         border-color: #06b6d4;
      }
   }

   .toolButton {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 32px;
      height: 32px;
      border: 0;
      border-radius: 7px;
      color: #fff;
      cursor: pointer;
      opacity: .85;

      &:hover {
         opacity: 1;
      }

      &.disabled {
         opacity: .45;
      }
   }

   .pageTabs {
      display: flex;
      flex-wrap: wrap;
      gap: 6px;
      margin-top: 11px;
   }

   .pageTab {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      padding: 5px 10px;
      border: 1px solid #cbd5e1;
      border-radius: 999px;
      background: #fff;
      color: #475569;
      font-size: 11px;
      font-weight: 600;
      cursor: pointer;
      transition: border-color .15s ease, background .15s ease, color .15s ease;

      &:hover {
         border-color: #06b6d4;
         color: #0e7490;
      }

      &.active {
         border-color: #06b6d4;
         background: #ecfeff;
         color: #0e7490;
      }
   }

   .pageTabBadge {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-width: 16px;
      height: 16px;
      padding: 0 4px;
      border-radius: 999px;
      background: #06b6d4;
      color: #fff;
      font-size: 9px;
      font-weight: 700;
   }

   .annotationLayout {
      display: grid;
      grid-template-columns: minmax(0, 1fr) 190px;
      gap: 12px;
      padding-top: 12px;
   }

   .canvasViewport {
      position: relative;
      display: flex;
      align-items: flex-start;
      justify-content: center;
      min-width: 0;
      min-height: 240px;
      max-height: 480px;
      overflow: auto;
      border: 1px solid #cbd5e1;
      border-radius: 8px;
      background: #e2e8f0;

      .canvas-container {
         flex: 0 0 auto;
         margin: 0;
      }
   }

   .canvasEmpty {
      position: absolute;
      inset: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      gap: 8px;
      padding: 25px;
      color: #64748b;
      font-size: 12px;
      text-align: center;

      svg {
         color: #94a3b8;
         font-size: 24px;
      }
   }

   .annotationList {
      min-width: 0;
      max-height: 480px;
      overflow: auto;
      padding: 10px;
      border: 1px solid #cbd5e1;
      border-radius: 8px;
      background: #fff;
   }

   .annotationListHeader {
      display: flex;
      justify-content: space-between;
      margin-bottom: 8px;
      color: #475569;
      font-size: 12px;
      font-weight: 650;
   }

   .annotationItem {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 6px;
      min-width: 0;
      padding: 7px 6px;
      border-radius: 6px;
      background: #f8fafc;

      &:not(:last-child) {
         margin-bottom: 5px;
      }

      > span {
         min-width: 0;
         overflow: hidden;
         color: #334155;
         font-size: 11px;
         text-overflow: ellipsis;
         white-space: nowrap;
      }

      button {
         display: flex;
         align-items: center;
         justify-content: center;
         flex: 0 0 auto;
         width: 22px;
         height: 22px;
         border: 0;
         border-radius: 5px;
         background: transparent;
         color: #94a3b8;
         cursor: pointer;

         &:hover {
            color: #dc2626;
            background: #fee2e2;
         }
      }
   }

   .annotationEmpty {
      display: block;
      padding: 16px 4px;
      color: #94a3b8;
      font-size: 11px;
      text-align: center;
   }

   .outputGrid {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 10px;

      > div {
         display: flex;
         flex-direction: column;
         gap: 5px;
         padding: 11px 12px;
         border: 1px solid #e2e8f0;
         border-radius: 9px;
         background: #f8fafc;

         strong {
            color: #334155;
            font-size: 12px;
         }

         span {
            color: #94a3b8;
            font-family: monospace;
            font-size: 10px;
         }
      }
   }

   // .annotations {
   //    position: absolute;
   //    margin-top: -70px;
   // }

   @media (max-width: 640px) {
      .editorHeader,
      .sectionHeading {
         flex-direction: column;
         gap: 8px;

         > span {
            text-align: left;
         }
      }

      .operationGrid,
      .sourceGrid,
      .outputGrid {
         grid-template-columns: 1fr;
      }

      .annotationLayout {
         grid-template-columns: 1fr;
      }

      .annotationList {
         max-height: 180px;
      }
   }
`;
